// Current question tracking
let currentQuestion = 1;
const totalQuestions = 8;
const quizStorageKey = 'skinQuizData';
const quizProfileKey = 'skinQuizProfile';
const quizCompletedKey = 'skinQuizCompleted';

// Animation state - prevents rapid clicking during transitions
let isAnimating = false;
const ANIMATION_DURATION = 400; // milliseconds for fade/slide transitions

// Start quiz from intro screen
function startQuiz() {
  const introScreen = document.getElementById('quizIntroScreen');
  const quizContainer = document.getElementById('skinQuiz');
  const progressBar = document.querySelector('.ebc-progress-bar');

  if (introScreen) {
    introScreen.style.display = 'none';
  }

  if (quizContainer) {
    quizContainer.style.display = 'block';
  }

  if (progressBar) {
    progressBar.style.display = 'block';
  }

  // Initialize the quiz display
  initializeSingleQuestionDisplay();
}

// Check for saved quiz data on page load
document.addEventListener('DOMContentLoaded', function() {
  loadFlickity();
  checkSavedQuizData();

  // Initialize single-question display
  initializeSingleQuestionDisplay();

  // Event delegation for dynamically created Add to Cart buttons
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.add-to-cart-btn');
    if (btn) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      addToCart(variantId, 1);
    }
  });
});

// Initialize single-question display mode
function initializeSingleQuestionDisplay() {
  const allQuestions = document.querySelectorAll('.quiz-question');

  // Hide all questions except the current one
  allQuestions.forEach((question, index) => {
    const questionNum = index + 1;
    if (questionNum === currentQuestion) {
      question.style.display = 'block';
      question.classList.remove('opacity-0', 'translate-y-4');
      question.classList.add('opacity-100', 'translate-y-0');
    } else {
      question.style.display = 'none';
      question.classList.add('opacity-0', 'translate-y-4');
      question.classList.remove('opacity-100', 'translate-y-0');
    }
  });

  // Update back button visibility
  updateBackButtonVisibility();

  // Update progress bar
  updateProgress(currentQuestion);
}

// Update back button visibility based on current question
function updateBackButtonVisibility() {
  const backButtons = document.querySelectorAll('.quiz-back-btn, [data-action="back"]');
  backButtons.forEach(btn => {
    if (currentQuestion > 1) {
      btn.style.display = 'inline-block';
      btn.style.visibility = 'visible';
    } else {
      btn.style.display = 'none';
      btn.style.visibility = 'hidden';
    }
  });
}

// Close quiz handler - confirms with user and navigates away
function closeQuiz() {
  if (confirm('Are you sure you want to exit the quiz? Your progress will be saved.')) {
    // Save current state before leaving
    saveQuizState();
    localStorage.setItem('skinQuizCurrentQuestion', currentQuestion.toString());

    // Navigate back or to homepage
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }
}

// Go to previous question with animation
function goToPreviousQuestion() {
  if (currentQuestion <= 1 || isAnimating) {
    return; // Already at first question or animation in progress
  }

  isAnimating = true;

  const currentEl = document.querySelector(`.quiz-question[data-question="${currentQuestion}"]`);
  const prevEl = document.querySelector(`.quiz-question[data-question="${currentQuestion - 1}"]`);

  if (!currentEl || !prevEl) {
    isAnimating = false;
    return;
  }

  // Animate current question out (fade out + slide down)
  currentEl.classList.remove('opacity-100', 'translate-y-0');
  currentEl.classList.add('opacity-0', 'translate-y-4');

  setTimeout(() => {
    // Hide current question
    currentEl.style.display = 'none';

    // Prepare previous question for entrance
    prevEl.style.display = 'block';
    prevEl.classList.add('opacity-0', 'translate-y-4');
    prevEl.classList.remove('opacity-100', 'translate-y-0');

    // Force reflow to ensure transition applies
    prevEl.offsetHeight;

    // Animate previous question in (fade in + slide up)
    prevEl.classList.remove('opacity-0', 'translate-y-4');
    prevEl.classList.add('opacity-100', 'translate-y-0');

    // Update current question index
    currentQuestion = currentQuestion - 1;

    // Update progress bar
    updateProgress(currentQuestion);

    // Update back button visibility
    updateBackButtonVisibility();

    // Save current question to localStorage
    localStorage.setItem('skinQuizCurrentQuestion', currentQuestion.toString());

    // Reset animation state after transition completes
    setTimeout(() => {
      isAnimating = false;
    }, ANIMATION_DURATION);

  }, ANIMATION_DURATION);
}

// Animate to next question with fade and slide effects
function animateToNextQuestion(fromQuestion, toQuestion) {
  if (isAnimating) return;

  isAnimating = true;

  const currentEl = document.querySelector(`.quiz-question[data-question="${fromQuestion}"]`);
  const nextEl = document.querySelector(`.quiz-question[data-question="${toQuestion}"]`);

  if (!currentEl || !nextEl) {
    isAnimating = false;
    return;
  }

  // Animate current question out (fade out + slide down)
  currentEl.classList.remove('opacity-100', 'translate-y-0');
  currentEl.classList.add('opacity-0', 'translate-y-4');

  setTimeout(() => {
    // Hide current question
    currentEl.style.display = 'none';

    // Prepare next question for entrance
    nextEl.style.display = 'block';
    nextEl.classList.add('opacity-0', 'translate-y-4');
    nextEl.classList.remove('opacity-100', 'translate-y-0');

    // Force reflow to ensure transition applies
    nextEl.offsetHeight;

    // Animate next question in (fade in + slide up)
    nextEl.classList.remove('opacity-0', 'translate-y-4');
    nextEl.classList.add('opacity-100', 'translate-y-0');

    // Update current question index
    currentQuestion = toQuestion;

    // Update progress bar with smooth transition
    updateProgress(currentQuestion);

    // Update back button visibility
    updateBackButtonVisibility();

    // Save current question to localStorage
    localStorage.setItem('skinQuizCurrentQuestion', currentQuestion.toString());

    // Reset animation state after transition completes
    setTimeout(() => {
      isAnimating = false;
    }, ANIMATION_DURATION);

  }, ANIMATION_DURATION);
}

// Load Flickity for product carousels
function loadFlickity() {
  if (!window.Flickity) {
    const flickityScript = document.createElement('script');
    flickityScript.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
    document.head.appendChild(flickityScript);

    const flickityStyles = document.createElement('link');
    flickityStyles.rel = 'stylesheet';
    flickityStyles.href = 'https://unpkg.com/flickity@2/dist/flickity.min.css';
    document.head.appendChild(flickityStyles);
  }
}

// Check for saved quiz data and offer to resume
function checkSavedQuizData() {
  console.group('Checking Saved Quiz Data');

  const savedData = localStorage.getItem(quizStorageKey);
  const quizCompleted = localStorage.getItem(quizCompletedKey) === 'true';
  const progressBar = document.querySelector('.ebc-progress-bar');

  console.log('Quiz data found in localStorage:', !!savedData);
  console.log('Quiz completed:', quizCompleted);

  if (savedData) {
    if (quizCompleted) {
      console.log('Quiz was previously completed - showing results');
      const savedProfile = JSON.parse(localStorage.getItem(quizProfileKey) || '{}');
      const formData = JSON.parse(savedData);

      console.log('Saved form data:', formData);
      console.log('Saved profile data:', savedProfile);

      displaySavedResults(formData, savedProfile);
    } else {
      console.log('Quiz was in progress - offering to resume');
      if (confirm("Would you like to continue your skin quiz from where you left off?")) {
        resumeQuiz(savedData);
      } else {
        clearQuizData();
        // Show intro screen when starting fresh
        if (progressBar) {
          progressBar.style.display = 'none';
        }
        updateProgress(1);
      }
    }
  } else {
    console.log('No saved data found - showing intro screen');
    // Hide progress bar on intro screen
    if (progressBar) {
      progressBar.style.display = 'none';
    }
    updateProgress(1);
  }

  console.groupEnd();
}

// Resume the quiz from saved point
function resumeQuiz(savedData) {
  const formData = JSON.parse(savedData);
  const lastQuestion = parseInt(localStorage.getItem('skinQuizCurrentQuestion') || '1');

  // Hide intro screen and show quiz container
  const introScreen = document.getElementById('quizIntroScreen');
  const quizContainer = document.getElementById('skinQuiz');
  const progressBar = document.querySelector('.ebc-progress-bar');

  if (introScreen) {
    introScreen.style.display = 'none';
  }

  if (quizContainer) {
    quizContainer.style.display = 'block';
  }

  if (progressBar) {
    progressBar.style.display = 'block';
  }

  // Populate previous answers
  populateFormWithSavedData(formData);

  // Update current question index
  currentQuestion = lastQuestion;

  // Show the right question with single-question display
  const allQuestions = document.querySelectorAll('.quiz-question');
  allQuestions.forEach((question, index) => {
    const questionNum = index + 1;
    if (questionNum === currentQuestion) {
      question.style.display = 'block';
      question.classList.remove('opacity-0', 'translate-y-4');
      question.classList.add('opacity-100', 'translate-y-0');
    } else {
      question.style.display = 'none';
      question.classList.add('opacity-0', 'translate-y-4');
      question.classList.remove('opacity-100', 'translate-y-0');
    }
  });

  updateProgress(currentQuestion);
  updateBackButtonVisibility();
}

// Populate the form with saved data
function populateFormWithSavedData(formData) {
  if (!formData.responses) return;

  const responses = formData.responses;

  // Set text field
  if (responses.name) {
    document.getElementById('name').value = responses.name;
  }

  // Set radio/select type fields
  const selectFields = ['age', 'skin-feel', 'sensitivity', 'pregnant'];
  selectFields.forEach(field => {
    if (responses[field]) {
      document.getElementById(field).value = responses[field];
      // Find and visually select the option
      const options = document.querySelectorAll(`.option-item[data-value="${responses[field]}"]`);
      options.forEach(opt => opt.classList.add('selected'));
    }
  });

  // Set multi-select fields
  const multiSelectFields = [
    { id: 'skin-concern', values: responses.skin_concerns || [] },
    { id: 'eye-concerns', values: responses.eye_concerns || [] }
  ];

  multiSelectFields.forEach(field => {
    if (field.values.length > 0) {
      document.getElementById(field.id).value = field.values.join(',');

      // Find and visually select the options
      field.values.forEach(value => {
        const options = document.querySelectorAll(`.option-item[data-value="${value}"]`);
        options.forEach(opt => opt.classList.add('selected'));
      });
    }
  });

  // Set SPF preferences
  if (responses.spf_preferences) {
    if (responses.spf_preferences.type) {
      document.getElementById('spf-type').value = responses.spf_preferences.type;
      const typeOptions = document.querySelectorAll(`.option-item[data-value="${responses.spf_preferences.type}"]`);
      typeOptions.forEach(opt => opt.classList.add('selected'));
    }

    if (responses.spf_preferences.color) {
      document.getElementById('spf-color').value = responses.spf_preferences.color;
      const colorOptions = document.querySelectorAll(`.option-item[data-value="${responses.spf_preferences.color}"]`);
      colorOptions.forEach(opt => opt.classList.add('selected'));
    }
  }
}

// Display saved results
function displaySavedResults(formData, profileData) {
  console.group('Displaying Saved Results');
  console.log('Form data:', formData);
  console.log('Profile data:', profileData);

  // Hide intro screen and show quiz container
  const introScreen = document.getElementById('quizIntroScreen');
  const quizContainer = document.getElementById('skinQuiz');

  if (introScreen) {
    introScreen.style.display = 'none';
  }

  if (quizContainer) {
    quizContainer.style.display = 'block';
  }

  // Display skin profile from saved data
  document.getElementById('skinProfile').innerHTML = `
    <p><strong>Name:</strong> ${formData.responses.name || 'User'}</p>
    <p><strong>Age:</strong> ${formData.responses.age}</p>
    <p><strong>Skin Type:</strong> ${profileData.skinType}</p>
    <p><strong>Sensitivity:</strong> ${profileData.sensitivity}</p>
    <p><strong>Main Concerns:</strong> ${profileData.concerns.join(', ')}</p>
  `;

  console.log('Building routines with saved profile data:');
  console.log('- Skin Type:', profileData.skinType);
  console.log('- Sensitivity:', profileData.sensitivity);
  console.log('- Primary Concern:', profileData.primaryConcern);
  console.log('- Sunscreen Preferences:', profileData.sunscreenPrefs);
  console.log('- Pregnant:', profileData.isPregnant);

  // Build routines using saved data
  buildMorningRoutine(profileData.skinType, profileData.sensitivity, profileData.primaryConcern, profileData.sunscreenPrefs);
  buildEveningRoutine(profileData.skinType, profileData.sensitivity, profileData.primaryConcern, profileData.isPregnant);

  // Hide all quiz questions and progress bar, show results
  document.querySelectorAll('.quiz-question').forEach(function(q) { q.style.display = 'none'; });
  var progressBar = document.querySelector('.quiz-progress');
  if (progressBar) progressBar.style.display = 'none';
  document.getElementById('quizResults').style.display = 'block';

  // Hide the separate sunscreen section
  const sunscreenSection = document.querySelector('.sunscreen-recommendation');
  if (sunscreenSection) {
    sunscreenSection.style.display = 'none';
  }

  console.groupEnd();
}

// Clear all quiz data from localStorage
function clearQuizData() {
  localStorage.removeItem(quizStorageKey);
  localStorage.removeItem(quizProfileKey);
  localStorage.removeItem(quizCompletedKey);
  localStorage.removeItem('skinQuizCurrentQuestion');
}

// Update progress bar
function updateProgress(questionNumber) {
  const progressPercent = ((questionNumber) / totalQuestions) * 100;
  const progressFill = document.getElementById('progressFill');
  const progressText = document.getElementById('progressText');

  if (progressFill) {
    progressFill.style.width = progressPercent + '%';
    // Add smooth transition via CSS, but also ensure inline style
    progressFill.style.transition = 'width 0.3s ease-in-out';
  }

  if (progressText) {
    progressText.textContent = `Question ${questionNumber} of ${totalQuestions}`;
  }
}

// Validate a question before proceeding
function validateQuestion(questionNum) {
  switch(questionNum) {
    case 1:
      // Name field (optional)
      return true;
    case 2:
      // Age
      const age = document.getElementById('age').value;
      if (!age) {
        alert("Please select your age range.");
        return false;
      }
      return true;
    case 3:
      // Skin feel
      const skinFeel = document.getElementById('skin-feel').value;
      if (!skinFeel) {
        alert("Please select how your skin feels.");
        return false;
      }
      return true;
    case 4:
      // Skin concerns
      const skinConcerns = document.getElementById('skin-concern').value;
      if (!skinConcerns) {
        alert("Please select at least one skin concern.");
        return false;
      }
      return true;
    case 5:
      // Sensitivity
      const sensitivity = document.getElementById('sensitivity').value;
      if (!sensitivity) {
        alert("Please select your skin sensitivity level.");
        return false;
      }
      return true;
    case 6:
      // Pregnant/breastfeeding
      const pregnant = document.getElementById('pregnant').value;
      if (!pregnant) {
        alert("Please indicate if you are pregnant or breastfeeding.");
        return false;
      }
      return true;
    case 7:
      // Eye concerns
      const eyeConcerns = document.getElementById('eye-concerns').value;
      if (!eyeConcerns) {
        alert("Please select at least one eye concern.");
        return false;
      }
      return true;
    case 8:
      // SPF preferences
      const spfType = document.getElementById('spf-type').value;
      const spfColor = document.getElementById('spf-color').value;
      if (!spfType || !spfColor) {
        alert("Please complete your sunscreen preferences.");
        return false;
      }
      return true;
    default:
      return true;
  }
}

// Define the collectFormData function if it's missing
function collectFormData() {
  const data = {
    responses: {
      name: document.getElementById('name').value,
      age: document.getElementById('age').value,
      skin_feel: document.getElementById('skin-feel').value,
      skin_concerns: document.getElementById('skin-concern').value.split(',').filter(Boolean),
      sensitivity: document.getElementById('sensitivity').value,
      pregnant_or_breastfeeding: document.getElementById('pregnant').value,
      eye_concerns: document.getElementById('eye-concerns').value.split(',').filter(Boolean),
      spf_preferences: {
        type: document.getElementById('spf-type').value,
        color: document.getElementById('spf-color').value
      }
    }
  };

  return data;
}

// Define selection functions
function selectOption(fieldId, element) {
  // Find parent container (handles both new quiz-options-grid and legacy ebc-options-grid)
  const parentContainer = element.closest('.quiz-options-grid') || element.closest('.ebc-options-grid') || element.parentElement;

  // Remove selected class from all option siblings (handles multiple class types)
  const options = parentContainer.querySelectorAll('.quiz-option, .ebc-option-item, .option-item');
  options.forEach(opt => opt.classList.remove('selected'));

  // Add selected class to clicked element
  element.classList.add('selected');

  // Set the hidden input value
  document.getElementById(fieldId).value = element.getAttribute('data-value');

  // Auto-advance to next question after a brief delay for visual feedback
  const questionContainer = element.closest('.quiz-question');
  if (questionContainer) {
    const questionNumber = parseInt(questionContainer.getAttribute('data-question'));
    setTimeout(() => {
      nextQuestion(questionNumber);
    }, 300);
  }
}

function selectMultipleOption(fieldId, element) {
  // Toggle selected class on clicked element
  element.classList.toggle('selected');

  // Find parent container
  const parentContainer = element.closest('.quiz-options-grid') || element.closest('.ebc-options-grid') || element.parentElement;

  // Get all selected values (handles multiple class types)
  const selectedOptions = parentContainer.querySelectorAll('.quiz-option.selected, .ebc-option-item.selected, .option-item.selected');
  const selectedValues = [];

  selectedOptions.forEach(opt => {
    selectedValues.push(opt.getAttribute('data-value'));
  });

  // Set the hidden input value as comma-separated string
  document.getElementById(fieldId).value = selectedValues.join(',');
}

// Add the previous question function (legacy support)
function prevQuestion(currentNum) {
  if (isAnimating) return;

  // Use animated transition
  goToPreviousQuestion();
}

// Go to next question with animation
function nextQuestion(currentNum) {
  if (isAnimating) return;

  if (validateQuestion(currentNum)) {
    // Save current state
    saveQuizState();

    // Use animated transition to next question
    animateToNextQuestion(currentNum, currentNum + 1);
  }
}

// Submit the quiz and display results
function submitQuiz() {
  if (validateQuestion(8)) {
    // Hide all quiz questions and progress bar
    document.querySelectorAll('.quiz-question').forEach(function(q) { q.style.display = 'none'; });
    var progressBar = document.querySelector('.quiz-progress');
    if (progressBar) progressBar.style.display = 'none';

    // Collect all form data
    const formData = collectFormData();

    // Generate recommendations
    const responses = formData.responses;
    const skinType = mapSkinFeelToType(responses.skin_feel);
    const sensitivity = mapSensitivity(responses.sensitivity);
    const concerns = mapSkinConcerns(responses.skin_concerns);
    const primaryConcern = concerns[0] || "Acne-Prone";
    const sunscreenPrefs = mapSunscreenPreferences(responses.spf_preferences);
    const isPregnant = responses.pregnant_or_breastfeeding === "Yes";

    // Make sure the data is saved consistently
    localStorage.setItem(quizStorageKey, JSON.stringify(formData));

    // Save profile data with normalized values
    const profileData = {
      name: responses.name || '',
      skinType,
      sensitivity,
      concerns,
      primaryConcern,
      sunscreenPrefs,
      isPregnant
    };

    localStorage.setItem(quizProfileKey, JSON.stringify(profileData));
    localStorage.setItem(quizCompletedKey, 'true');

    console.log('Saved form data:', formData);
    console.log('Saved profile data:', profileData);

    // Display skin profile
    document.getElementById('skinProfile').innerHTML = `
      <p><strong>Name:</strong> ${responses.name || 'User'}</p>
      <p><strong>Age:</strong> ${responses.age}</p>
      <p><strong>Skin Type:</strong> ${skinType}</p>
      <p><strong>Sensitivity:</strong> ${sensitivity}</p>
      <p><strong>Main Concerns:</strong> ${concerns.join(', ')}</p>
    `;

    // Build the routines using metaobjects
    buildMorningRoutine(skinType, sensitivity, primaryConcern, sunscreenPrefs);
    buildEveningRoutine(skinType, sensitivity, primaryConcern, isPregnant);

    // Store JSON results for debugging
    document.getElementById('quizJsonResults').textContent = JSON.stringify({
      formData,
      profileData
    }, null, 2);

    // Redirect to the results page
    window.location.href = '/pages/skin-type-results';

    // Hide the separate sunscreen section since it's now part of morning routine
    const sunscreenSection = document.querySelector('.sunscreen-recommendation');
    if (sunscreenSection) {
      sunscreenSection.style.display = 'none';
    }
  }
}

// Build morning routine using metaobjects
function buildMorningRoutine(skinType, sensitivity, primaryConcern, sunscreenPrefs) {
  console.log('Building morning routine:', { skinType, sensitivity, primaryConcern, sunscreenPrefs });

  const container = document.getElementById('morningRoutineSteps');
  if (!container) {
    console.error('Morning routine container not found!');
    return;
  }

  container.innerHTML = ''; // Clear container

  // Remove skin type from titles
  addRoutineStepWithCarousel(container, '1. Cleanser', skinType, sensitivity, primaryConcern, 'am_cleanser');
  addRoutineStepWithCarousel(container, '2. Eye Cream', skinType, sensitivity, primaryConcern, 'eye_cream');

  const treatmentField = primaryConcern === 'Hyperpigmentation' ? 'pigment_treatment' : 'non_pigment_treatment';
  addRoutineStepWithCarousel(container, '3. Treatment', skinType, sensitivity, primaryConcern, treatmentField);

  addRoutineStepWithCarousel(container, '4. Moisturizer', skinType, sensitivity, primaryConcern, 'moisturizer');

  const sunscreenField = getSunscreenField(sunscreenPrefs);
  addRoutineStepWithCarousel(container, '5. Sunscreen', skinType, sensitivity, primaryConcern, sunscreenField);
}

// Build evening routine using metaobjects
function buildEveningRoutine(skinType, sensitivity, primaryConcern, isPregnant) {
  console.log('Building evening routine:', { skinType, sensitivity, primaryConcern, isPregnant });

  const container = document.getElementById('eveningRoutineSteps');
  if (!container) {
    console.error('Evening routine container not found!');
    return;
  }

  container.innerHTML = ''; // Clear container

  // Remove skin type from titles
  addRoutineStepWithCarousel(container, '1. Cleanser', skinType, sensitivity, primaryConcern, 'pm_cleanser');
  addRoutineStepWithCarousel(container, '2. Eye Cream', skinType, sensitivity, primaryConcern, 'eye_cream');

  const treatmentField = primaryConcern === 'Hyperpigmentation' ? 'pigment_treatment' : 'non_pigment_treatment';
  addRoutineStepWithCarousel(container, '3. Treatment', skinType, sensitivity, primaryConcern, treatmentField);

  if (isPregnant) {
    const stepContainer = document.createElement('div');
    stepContainer.className = 'routine-step-carousel';
    stepContainer.innerHTML = `
      <div class="step-title">4. Retinol/Retinoid</div>
      <p class="pregnancy-note">Not recommended during pregnancy or breastfeeding. We recommend these alternatives:</p>
    `;

    const carousel = document.createElement('div');
    carousel.className = 'product-carousel';
    stepContainer.appendChild(carousel);
    container.appendChild(stepContainer);

    fetchProductsForRoutineStep(carousel, skinType, sensitivity, primaryConcern, 'retinol_alternative');
  } else {
    addRoutineStepWithCarousel(container, '4. Retinol/Retinoid', skinType, sensitivity, primaryConcern, 'retinol');
  }

  addRoutineStepWithCarousel(container, '5. Moisturizer', skinType, sensitivity, primaryConcern, 'moisturizer');
}

// Helper function to determine which sunscreen field to use
function getSunscreenField(sunscreenPrefs) {
  if (!sunscreenPrefs) return 'physical_untinted';

  const { type, color } = sunscreenPrefs;

  if (type === 'Physical' && color === 'Untinted') return 'physical_untinted';
  if (type === 'Physical' && color === 'Tinted') return 'physical_tinted';
  if (type === 'Chemical' && color === 'Untinted') return 'chemical_untinted';
  if (type === 'Chemical' && color === 'Tinted') return 'chemical_tinted';
  if (type === 'NoPreference' && color === 'Untinted') return 'no_preference_untinted';
  if (type === 'NoPreference' && color === 'Tinted') return 'no_preference_tinted';

  // Default options
  return 'no_preference_all';
}

// Find and replace the addRoutineStepWithCarousel function to use our new createProductCard function
function addRoutineStepWithCarousel(containerElement, stepTitle, skinType, sensitivity, primaryConcern, fieldName) {
  // Create the step container
  const stepContainer = document.createElement('div');
  stepContainer.className = 'routine-step';
  stepContainer.innerHTML = `
    <h3 class="step-title">${stepTitle}</h3>
  `;

  // Create the carousel container
  const carouselContainer = document.createElement('div');
  carouselContainer.className = 'routine-carousel';
  carouselContainer.id = `${fieldName}-carousel`;

  // Append the carousel container to the step container
  stepContainer.appendChild(carouselContainer);

  // Append the step container to the provided container element
  containerElement.appendChild(stepContainer);

  // Now fetch products and populate the carousel with correct parameter order
  fetchProductsForRoutineStep(carouselContainer, skinType, sensitivity, primaryConcern, fieldName);
}

// Helper: compare a metaobject field (may be array or string) with a string value
function fieldMatches(fieldValue, searchValue) {
  if (Array.isArray(fieldValue)) {
    return fieldValue.includes(searchValue);
  }
  return fieldValue === searchValue;
}

// Update the fetchProductsForRoutineStep function to fix the matching logic
function fetchProductsForRoutineStep(carouselElement, skinType, sensitivity, primaryConcern, fieldName) {
  console.group(`Fetching Products for ${fieldName}`);
  console.log('Query parameters:', { skinType, sensitivity, primaryConcern, fieldName });

  try {
    // Get the routine products data from the embedded JSON
    const routineProductsData = JSON.parse(document.getElementById('routineProductsData').textContent);
    const allRoutines = routineProductsData.routines;

    console.log(`Found ${allRoutines.length} total routines in metaobjects`);

    // Helper: check if a routine has real products for the requested field
    function hasProductsForField(routine, field) {
      var val = routine.products && routine.products[field];
      if (!val) return false;
      if (Array.isArray(val) && val.length > 0) return true;
      if (typeof val === 'string' && val !== '[]' && val !== '') return true;
      return false;
    }

    // Find matching routine - prefer routines that have products for the requested field
    let matchingRoutine = null;

    // Try exact match first (with products for this field)
    for (const routine of allRoutines) {
      if (fieldMatches(routine.skin_type, skinType) &&
          fieldMatches(routine.sensitivity, sensitivity) &&
          fieldMatches(routine.concern, primaryConcern) &&
          hasProductsForField(routine, fieldName)) {
        console.log('Found exact match with products!');
        matchingRoutine = routine;
        break;
      }
    }

    // Try exact match without product check
    if (!matchingRoutine) {
      for (const routine of allRoutines) {
        if (fieldMatches(routine.skin_type, skinType) &&
            fieldMatches(routine.sensitivity, sensitivity) &&
            fieldMatches(routine.concern, primaryConcern)) {
          console.log('Found exact match (no products for this field)');
          matchingRoutine = routine;
          break;
        }
      }
    }

    // If no exact match, try relaxed match preferring routines with products
    if (!matchingRoutine) {
      for (const routine of allRoutines) {
        if (fieldMatches(routine.skin_type, skinType) &&
            (fieldMatches(routine.concern, primaryConcern) || fieldMatches(routine.sensitivity, sensitivity)) &&
            hasProductsForField(routine, fieldName)) {
          console.log('Found partial match with products');
          matchingRoutine = routine;
          break;
        }
      }
    }

    // Relaxed match without product check
    if (!matchingRoutine) {
      for (const routine of allRoutines) {
        if (fieldMatches(routine.skin_type, skinType) &&
            (fieldMatches(routine.concern, primaryConcern) || fieldMatches(routine.sensitivity, sensitivity))) {
          console.log('Found partial match');
          matchingRoutine = routine;
          break;
        }
      }
    }

    // Skin type only, prefer with products
    if (!matchingRoutine) {
      for (const routine of allRoutines) {
        if (fieldMatches(routine.skin_type, skinType) && hasProductsForField(routine, fieldName)) {
          console.log('Found skin type match with products');
          matchingRoutine = routine;
          break;
        }
      }
    }

    // Skin type only fallback
    if (!matchingRoutine) {
      for (const routine of allRoutines) {
        if (fieldMatches(routine.skin_type, skinType)) {
          console.log('Found skin type match only');
          matchingRoutine = routine;
          break;
        }
      }
    }

    // If still no match, just use the first available routine
    if (!matchingRoutine && allRoutines.length > 0) {
      console.log('No specific match found, using first available routine');
      matchingRoutine = allRoutines[0];
    }

    // Check if the matching routine has products for this field
    if (matchingRoutine && matchingRoutine.products && matchingRoutine.products[fieldName]) {
      let products = matchingRoutine.products[fieldName];

      // Handle double-encoded empty arrays from Liquid default filter
      if (typeof products === 'string') {
        try { products = JSON.parse(products); } catch(e) { products = []; }
      }
      if (!Array.isArray(products) || products.length === 0) {
        console.log(`No products found for ${fieldName}`);
        carouselElement.innerHTML = '<p class="no-products">No products available for this step.</p>';
        console.groupEnd();
        return;
      }

      console.log(`Processing ${products.length} products for ${fieldName}`);

      // Generate HTML for the carousel
      let carouselHTML = '';

      // Process each product
      for (const product of products) {
        console.log('Raw product data:', product);

        // Use our new createProductCard function to generate the product HTML
        carouselHTML += createProductCard(product);
      }

      // Set the carousel HTML
      carouselElement.innerHTML = carouselHTML;

      // Initialize Flickity
      if (window.Flickity) {
        const flkty = new Flickity(carouselElement, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          wrapAround: true,
          prevNextButtons: true,
          adaptiveHeight: false,
          setGallerySize: true,
          groupCells: '100%'
        });
      } else {
        console.warn('Flickity not loaded yet, trying again in 500ms');
        setTimeout(() => {
          if (window.Flickity) {
            const flkty = new Flickity(carouselElement, {
              cellAlign: 'left',
              contain: true,
              pageDots: true,
              wrapAround: true,
              prevNextButtons: true,
              adaptiveHeight: false,
              setGallerySize: true,
              groupCells: '100%'
            });
          } else {
            console.error('Flickity still not available');
          }
        }, 500);
      }
    } else {
      console.log(`No products found for ${fieldName}`);
      carouselElement.innerHTML = `<p>No products found for this step. Please try again.</p>`;
    }
  } catch (error) {
    console.error('Error processing products:', error);
    carouselElement.innerHTML = `<p>Error loading products. Please try again.</p>`;
  }

  console.groupEnd();
}

// Debug panel - disabled in production
// To enable debugging, call toggleDebugInfo() from browser console

// Function to toggle debug information
function toggleDebugInfo() {
  const debugInfo = document.getElementById('debugInfo');
  if (debugInfo.style.display === 'none') {
    debugInfo.style.display = 'block';
    populateDebugInfo();
  } else {
    debugInfo.style.display = 'none';
  }
}

// Function to populate debug information
function populateDebugInfo() {
  try {
    // Get routine products data
    const dataElement = document.getElementById('routineProductsData');
    if (!dataElement) {
      console.warn('[SKIN-QUIZ] routineProductsData element not found');
      return;
    }
    const routineProductsData = JSON.parse(dataElement.textContent);
    if (!routineProductsData || !routineProductsData.routines) {
      console.warn('[SKIN-QUIZ] Invalid routine products data structure');
      return;
    }
    const routines = routineProductsData.routines;

  // Display routines summary
  let routinesHtml = '<ul>';
  routines.forEach((routine, index) => {
    routinesHtml += `
      <li>
        <strong>Routine ${index + 1}</strong>:
        Handle: ${routine.handle},
        Skin Type: ${routine.skin_type},
        Sensitivity: ${routine.sensitivity},
        Concern: ${routine.concern}
      </li>
    `;
  });
  routinesHtml += '</ul>';
  document.getElementById('routineProductsDebug').innerHTML = routinesHtml;

  // Display all AM Cleanser data
  let amCleanserHtml = '<ul>';
  routines.forEach((routine, index) => {
    if (routine.products && routine.products.am_cleanser) {
      amCleanserHtml += `
        <li>
          <strong>Routine ${index + 1} (${routine.handle})</strong>:
          <pre>${JSON.stringify(routine.products.am_cleanser, null, 2)}</pre>
        </li>
      `;
    } else {
      amCleanserHtml += `
        <li>
          <strong>Routine ${index + 1} (${routine.handle})</strong>:
          No AM Cleanser products defined
        </li>
      `;
    }
  });
  amCleanserHtml += '</ul>';
  document.getElementById('amCleanserDebug').innerHTML = amCleanserHtml;
  } catch (error) {
    console.error('[SKIN-QUIZ] Error populating debug info:', error);
  }
}

// Make sure we have a proper addToCart function
function addToCart(variantId, quantity) {
  if (!variantId) {
    console.error('No variant ID provided for adding to cart');
    alert('Sorry, there was an error adding this product to your cart.');
    return;
  }

  console.log(`Adding variant ${variantId} to cart (quantity: ${quantity})`);

  // Use Shopify's Cart API to add the item
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    alert('Product added to your cart!');

    // Refresh the cart count display if available
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('There was an error adding this product to your cart. Please try again.');
  });
}

// Map skin feel to skin type
// Note: Only "Dry" and "Oily" have metaobject configurations
function mapSkinFeelToType(skinFeel) {
  if (!skinFeel) return "Dry"; // Default

  const feel = skinFeel.toLowerCase();

  if (feel.includes("oily all over")) {
    return "Oily";
  } else if (feel.includes("oily in certain spots")) {
    // Map to Oily (closest match with configured metaobjects)
    return "Oily";
  } else if (feel.includes("dry")) {
    return "Dry";
  } else if (feel.includes("not too oily") && feel.includes("not too dry")) {
    // Map to Dry (closest match with configured metaobjects)
    return "Dry";
  }

  return "Dry"; // Default if no match
}

// Map sensitivity response
function mapSensitivity(sensitivity) {
  if (!sensitivity) return "Not Sensitive"; // Default

  const sens = sensitivity.toLowerCase();

  if (sens.includes("very sensitive") || sens.includes("allergic")) {
    return "Sensitive";
  } else if (sens.includes("resistant") || sens.includes("not too sensitive")) {
    return "Not Sensitive";
  } else if (sens.includes("not sure")) {
    // Map to "Not Sensitive" as metaobjects only have "Sensitive" and "Not Sensitive"
    return "Not Sensitive";
  }

  return "Not Sensitive"; // Default
}

// Map skin concerns
function mapSkinConcerns(concerns) {
  if (!concerns || concerns.length === 0) {
    return ["General Skin Health"]; // Default
  }

  const mappedConcerns = [];

  for (const concern of concerns) {
    const concernLower = concern.toLowerCase();

    if (concernLower.includes("acne") || concernLower.includes("breakout")) {
      mappedConcerns.push("Acne-Prone");
    } else if (concernLower.includes("dry") || concernLower.includes("flaky")) {
      mappedConcerns.push("Dryness");
    } else if (concernLower.includes("fine line") || concernLower.includes("wrinkle")) {
      mappedConcerns.push("Anti-Aging");
    } else if (concernLower.includes("hyperpigmentation") || concernLower.includes("discoloration")) {
      mappedConcerns.push("Hyperpigmentation");
    } else {
      mappedConcerns.push(concern); // Keep original if no mapping
    }
  }

  return mappedConcerns;
}

// Map sunscreen preferences
function mapSunscreenPreferences(preferences) {
  if (!preferences || !preferences.type || !preferences.color) {
    return { type: "Physical", color: "Untinted" }; // Default
  }

  let sunscreenType = "Physical"; // Default
  if (preferences.type.toLowerCase().includes("physical") || preferences.type.toLowerCase().includes("mineral")) {
    sunscreenType = "Physical";
  } else if (preferences.type.toLowerCase().includes("chemical")) {
    sunscreenType = "Chemical";
  } else if (preferences.type.toLowerCase().includes("no preference")) {
    sunscreenType = "NoPreference"; // Fixed to match the storage format needed
  }

  let sunscreenColor = "Untinted"; // Default
  if (preferences.color.toLowerCase().includes("tinted")) {
    sunscreenColor = "Tinted";
  } else {
    sunscreenColor = "Untinted"; // Explicitly set untinted
  }

  return { type: sunscreenType, color: sunscreenColor };
}

// Save current quiz state to localStorage
function saveQuizState() {
  const formData = collectFormData();
  localStorage.setItem(quizStorageKey, JSON.stringify(formData));
}

// Add a function to clear quiz data to make testing easier
function resetQuiz() {
  if (confirm('Are you sure you want to clear your quiz data and start over?')) {
    localStorage.removeItem(quizStorageKey);
    localStorage.removeItem(quizProfileKey);
    localStorage.removeItem(quizCompletedKey);
    localStorage.removeItem('skinQuizCurrentQuestion');
    window.location.reload();
  }
}

// Add this to the DOMContentLoaded event
document.addEventListener('DOMContentLoaded', function() {
  console.log('Skin Quiz loaded');

  // Add Enter key handler for name input to auto-advance
  const nameInput = document.getElementById('name');
  if (nameInput) {
    nameInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (this.value.trim()) {
          nextQuestion(1);
        }
      }
    });
  }

  loadFlickity();
  checkSavedQuizData();

  // Log contents of routineProductsData
  setTimeout(() => {
    try {
      const routineProductsData = JSON.parse(document.getElementById('routineProductsData').textContent);
      console.group('Metaobject Data Overview');
      console.log(`Total routines: ${routineProductsData.routines.length}`);

      // Log all routine handles
      console.log('Available routines:');
      routineProductsData.routines.forEach((routine, index) => {
        console.log(`${index + 1}. ${routine.handle} (${routine.skin_type}, ${routine.sensitivity}, ${routine.concern})`);
      });

      console.groupEnd();
    } catch (error) {
      console.error('Error parsing routineProductsData:', error);
    }
  }, 500);
});

// Add this function to the file to get full product data logging
function logAllProductData() {
  console.group('All Products from Metaobjects');

  try {
    const routineProductsData = JSON.parse(document.getElementById('routineProductsData').textContent);
    const allRoutines = routineProductsData.routines;

    // Count total products
    let totalProducts = 0;
    let productCategories = {};

    // First pass: gather stats
    allRoutines.forEach(routine => {
      if (!routine.products) return;

      Object.entries(routine.products).forEach(([category, products]) => {
        if (!Array.isArray(products)) return;

        totalProducts += products.length;

        if (!productCategories[category]) {
          productCategories[category] = products.length;
        } else {
          productCategories[category] += products.length;
        }
      });
    });

    console.log(`Found ${totalProducts} total products across ${Object.keys(productCategories).length} categories`);
    console.log('Product counts by category:', productCategories);

    // Second pass: show product details
    allRoutines.forEach((routine, routineIndex) => {
      console.group(`Routine ${routineIndex + 1}: ${routine.handle || 'Unnamed'} (${routine.skin_type}, ${routine.sensitivity}, ${routine.concern})`);

      if (!routine.products) {
        console.log('No products defined for this routine');
        console.groupEnd();
        return;
      }

      Object.entries(routine.products).forEach(([category, products]) => {
        if (!Array.isArray(products) || products.length === 0) {
          console.log(`${category}: No products`);
          return;
        }

        console.group(`${category}: ${products.length} products`);

        products.forEach((product, index) => {
          console.group(`Product ${index + 1}: ${product.title || 'Unnamed'}`);
          console.log('ID:', product.id);
          console.log('Handle:', product.handle);
          console.log('Images:', product.images?.length || 0, 'available');

          // Look for the image in multiple possible locations
          const possibleImages = [
            product.featured_image,
            product.images?.[0],
            product.variants?.[0]?.featured_image?.src,
            product.media?.[0]?.src
          ].filter(img => img);

          console.log('Possible images:', possibleImages);

          if (product.variants && product.variants.length > 0) {
            console.log('First variant:', {
              id: product.variants[0].id,
              sku: product.variants[0].sku,
              price: product.variants[0].price
            });
          }

          console.groupEnd();
        });

        console.groupEnd();
      });

      console.groupEnd();
    });

    // Add product data to debug panel
    const debugPanel = document.getElementById('debugInfo');
    if (debugPanel) {
      const allProductsSection = document.createElement('div');
      allProductsSection.innerHTML = `
        <h4>All Products Summary:</h4>
        <p>${totalProducts} total products across ${Object.keys(productCategories).length} categories</p>
        <ul>
          ${Object.entries(productCategories).map(([category, count]) =>
            `<li>${category}: ${count} products</li>`
          ).join('')}
        </ul>
        <button id="showAllProductsBtn" style="padding: 5px 10px; margin-top: 10px; background: #4a90e2; color: white; border: none; border-radius: 4px;">
          Show All Product Details
        </button>
        <div id="allProductsDetail" style="display: none;"></div>
      `;

      debugPanel.appendChild(allProductsSection);

      // Add click handler for the show all products button
      setTimeout(() => {
        const showBtn = document.getElementById('showAllProductsBtn');
        const detailsContainer = document.getElementById('allProductsDetail');

        if (showBtn && detailsContainer) {
          showBtn.addEventListener('click', () => {
            if (detailsContainer.style.display === 'none') {
              let productHtml = '<h4>Detailed Product Data:</h4>';

              allRoutines.forEach((routine, routineIndex) => {
                productHtml += `<div style="margin-top: 15px;"><strong>Routine ${routineIndex + 1}: ${routine.handle || 'Unnamed'}</strong> (${routine.skin_type}, ${routine.sensitivity}, ${routine.concern})</div>`;

                if (!routine.products) {
                  productHtml += '<p>No products defined for this routine</p>';
                  return;
                }

                Object.entries(routine.products).forEach(([category, products]) => {
                  if (!Array.isArray(products) || products.length === 0) {
                    return;
                  }

                  productHtml += `<div style="margin-left: 15px; margin-top: 10px;"><strong>${category}:</strong> ${products.length} products</div>`;

                  products.forEach((product, index) => {
                    const imageUrl = product.featured_image ||
                                     product.images?.[0] ||
                                     product.variants?.[0]?.featured_image?.src ||
                                     product.media?.[0]?.src || '';

                    productHtml += `
                      <div style="margin-left: 30px; margin-top: 5px; padding: 5px; border: 1px solid #eee;">
                        <div><strong>${product.title || 'Unnamed Product'}</strong></div>
                        <div>ID: ${product.id}</div>
                        <div>Handle: ${product.handle}</div>
                        ${imageUrl ? `<div>Image: <img src="${imageUrl}" style="max-width: 100px; max-height: 100px;"></div>` : ''}
                        <div>Price: ${product.price ? formatMoney(product.price) : 'N/A'}</div>
                      </div>
                    `;
                  });
                });
              });

              detailsContainer.innerHTML = productHtml;
              detailsContainer.style.display = 'block';
              showBtn.textContent = 'Hide Product Details';
            } else {
              detailsContainer.style.display = 'none';
              showBtn.textContent = 'Show All Product Details';
            }
          });
        }
      }, 100);
    }
  } catch (error) {
    console.error('Error logging product data:', error);
  }

  console.groupEnd();
}

// Debug logging - disabled in production
// To enable, call logAllProductData() from browser console

// Escape HTML to prevent XSS attacks
function escapeHtml(text) {
  if (text == null) return '';
  const div = document.createElement('div');
  div.textContent = String(text);
  return div.innerHTML;
}

// Format money - handles both cents (integer) and formatted strings
function formatMoney(amount, format) {
  // Handle null/undefined
  if (amount == null) return '$0.00';

  let cents;

  if (typeof amount === 'string') {
    // Remove currency symbols and whitespace
    const cleaned = amount.replace(/[$,\s]/g, '');

    // Check if it's a decimal string like "21.00" or integer string like "2100"
    if (cleaned.includes('.')) {
      // It's a formatted price like "21.00" - convert to cents
      cents = Math.round(parseFloat(cleaned) * 100);
    } else {
      // It's already in cents like "2100"
      cents = parseInt(cleaned, 10);
    }
  } else if (typeof amount === 'number') {
    // If it's a small number (< 1000), assume it's dollars, else cents
    // Most products are > $10 so this heuristic works
    cents = amount < 1000 ? Math.round(amount * 100) : Math.round(amount);
  } else {
    cents = 0;
  }

  // Ensure it's a valid number
  if (isNaN(cents)) cents = 0;

  const dollars = Math.floor(Math.abs(cents) / 100);
  const centsPart = (Math.abs(cents) % 100).toString().padStart(2, '0');
  const sign = cents < 0 ? '-' : '';

  return `${sign}$${dollars}.${centsPart}`;
}

// Update the createProductCard function to use the correct product name field
function createProductCard(product) {
  // Get the first variant or default to null
  const variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
  const variantId = variant ? variant.id : '';

  // Extract image URL correctly (checking multiple possible sources)
  let imageUrl = '';
  if (product.featured_image && typeof product.featured_image === 'string') {
    imageUrl = product.featured_image;
  } else if (product.featured_image && product.featured_image.src) {
    imageUrl = product.featured_image.src;
  } else if (product.images && product.images.length > 0) {
    imageUrl = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
  } else if (variant && variant.featured_image) {
    imageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image.src || '');
  }

  // Use the name field which already contains the full product name with variant
  const displayTitle = product.name || product.title || '';

  // Format the prices
  let priceHtml = '';

  if (variant) {
    const regularPrice = formatMoney(variant.price);

    // Check if there's a compare_at_price and it's greater than the regular price
    if (variant.compare_at_price && parseInt(variant.compare_at_price) > parseInt(variant.price)) {
      const comparePrice = formatMoney(variant.compare_at_price);
      const discountPercent = Math.round((parseInt(variant.compare_at_price) - parseInt(variant.price)) / parseInt(variant.compare_at_price) * 100);

      priceHtml = `
        <span class="original-price">${comparePrice}</span>
        <span class="sale-price">${regularPrice}</span>
        <span class="discount-badge">${discountPercent}% OFF</span>
      `;
    } else {
      priceHtml = regularPrice;
    }
  } else if (product.price) {
    priceHtml = formatMoney(product.price);
  } else {
    priceHtml = 'Price unavailable';
  }

  // Format the SKU
  const sku = variant && variant.sku ? variant.sku : (product.sku || 'N/A');

  // Escape user content to prevent XSS
  const safeTitle = escapeHtml(displayTitle);
  const safeSku = escapeHtml(sku);
  const safeImageUrl = escapeHtml(imageUrl);
  const safeVariantId = escapeHtml(variantId || product.variant_id || '');

  // Build the HTML for the product card
  return `
    <div class="product-card">
      <div class="product-image">
        <img src="${safeImageUrl}" alt="${safeTitle}" loading="lazy">
      </div>
      <div class="product-title">${safeTitle}</div>
      <div class="product-sku">SKU: ${safeSku}</div>
      <div class="product-price">${priceHtml}</div>
      <button class="add-to-cart-btn" data-variant-id="${safeVariantId}">Add to Cart</button>
    </div>
  `;
}
